<script>
   /***************************************************************/
   /* Select                                                      */
   /* --------------------                                        */
   /* control element for selecting among a few options           */
   /***************************************************************/

   export let id;                         // text ID of the input element
   export let value = '';                 // initial selected value
   export let className = '';             // extra class name
   export let placeholder = '';           // placeholder (hint)
   export let maxLength = 25;             // maximum number of characters

</script>

<div class="textinput {className}">
<input type="text" name={id} {placeholder} maxlength={maxLength} bind:value={value}>
</div>

<style>

   .textinput {
      position: relative;
      box-sizing: border-box;
      flex: 1 1 auto;
      font-size: 1em;
      line-height: 1.5em;
      margin: 0;
      padding: 0.15em 0;
      width: auto;
      border-radius: 2px;
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      display: flex;
   }

   .textinput > input {
      cursor: default;
      padding: 0.25em 0.5em;
      margin: 0 0.2em 0 0;
      color: #606060;
      background-color: #f0f0f0;
      border: 1px solid #a0a0a0;
      border-radius: 0.3em;
      outline: none;
   }

   .textinput > input:focus,
   .textinput > input:active {
      border: 1px solid #66abec;
      background-color: #6eb8ff20;
      color: #4777a4;
   }
</style>